import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export enum DaySinceFromTransactionTypes {
  NOT_EXCEED_30_DAYS = 1,
  FROM_30_TO_60_DAYS = 2,
  EXCEED_60_DAYS = 3,
}

export type MemberModel = {
  avatarUrl: string;
  dateOfBirth: string;
  displayName: string;
  districtId: string;
  email: string;
  id: string;
  isActive: boolean;
  phoneNumber: string;
  provinceId: string;
  role: string;
  roleName: string;
  sex: number;
  type: number;
  zaloAvatar: string;
  zaloId: string;
  zaloIdByOA: string;
  address: string;
  daysFromLastTransaction: null;
  phoneNumberConfirmed: false;
  stores: Array<{ color: string; id: number; name: string }>;
  totalTransactions: 0;
};

export type GetMemberRequestModel = {
  id?: number;
};
export type GetMemberResponseModel = DObjectResponse<MemberModel>;

export type ListMemberRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  keyword?: string;
  isActive?: boolean | null;
  orderByName?: string;
  orderByType?: string;
  toDaysFromLastTransaction?: number;
  fromDaysFromLastTransaction?: number;
  storeId?: number | null;
};
export type ListMemberResponseModel = DListResponse<MemberModel>;

export type SaveMemberRequestModel = {
  id?: number;
  question: string;
  answer: string;
  orderNo?: number | null;
};
export type SaveMemberResponseModel = DObjectResponse<boolean>;

export type DeleteMemberRequestModel = {
  id?: number | string;
};
export type DeleteMemberResponseModel = DObjectResponse<boolean>;

export type InactiveMemberRequestModel = {
  id?: number | string;
};
export type InactiveMemberResponseModel = DObjectResponse<boolean>;

export type ActiveMemberRequestModel = {
  id?: number | string;
};
export type ActiveMemberResponseModel = DObjectResponse<boolean>;

export interface MemberStateModel {
  memberListData: DList<MemberModel> | null;
  memberDetail: MemberModel | null;
  triggerSaveMember: TriggerTypes | null;
  isTableSelectAllCheckbox: boolean;
  tableSelectCheckboxIds: number[];

  loadingList: boolean;
  loadingDetail: boolean;
}
